var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3097 160.82C58.0089 160.82 63.4397 155.389 63.4397 148.69C63.4397 141.991 58.0089 136.56 51.3097 136.56C44.6105 136.56 39.1797 141.991 39.1797 148.69C39.1797 155.389 44.6105 160.82 51.3097 160.82Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1003 124.06C41.8703 116.69 40.0703 108.55 40.0703 100C40.0703 66.9 66.9003 40.07 100 40.07M100 159.92C133.1 159.92 159.93 133.09 159.93 99.99C159.93 91.39 158.12 83.21 154.86 75.82M89.3503 52.82L102.11 40.06L89.3703 27.32M110.54 147.17L97.7803 159.93L110.52 172.67",
    stroke: "url(#paint0_linear_285_3849)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7502 146.22C77.8302 147.03 77.8602 147.86 77.8602 148.69C77.8602 163.36 65.9702 175.25 51.3002 175.25C36.6302 175.25 24.7402 163.36 24.7402 148.69C24.7402 134.02 36.6302 122.13 51.3002 122.13C52.6402 122.13 53.9302 122.23 55.2102 122.42L122.65 54.5C121.65 46.67 124.14 38.48 130.15 32.46C138.28 24.33 150.39 22.63 160.21 27.32L142.61 44.92C139.17 48.36 139.17 53.94 142.61 57.38C146.05 60.82 151.63 60.82 155.07 57.38L172.67 39.78C177.36 49.6 175.66 61.71 167.53 69.84C161.51 75.86 153.33 78.34 145.49 77.34L77.7502 146.22V146.22Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_285_3849",
    x1: 38.0703,
    y1: 100,
    x2: 161.93,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2074D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest4);
export default __webpack_public_path__ + "static/media/test4.fa2e1baa951f567d35f4e6d6240822e1.svg";
export { ForwardRef as ReactComponent };